export default __webpack_public_path__ + "static/media/pte_2.7622a521.png";